// extracted by mini-css-extract-plugin
export var cookiesSection = "d6_Jp";
export var cookiesSection__btn = "d6_Js";
export var cookiesSection__link = "d6_Jr";
export var cookiesSection__text = "d6_Jq";
export var cookiesSection__wrapper = "d6_Jn";